// extracted by mini-css-extract-plugin
export default {"wrapper":"Status_wrapper__MdHgG"};